import React, { useEffect, useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import dayjs from 'dayjs';
import es from 'dayjs/locale/es';
import {
  Avatar,
  Card,
  Grid,
  Button,
  Divider,
  CardActions,
  CardContent,
  Typography,
  makeStyles
} from '@material-ui/core';

dayjs.locale(es);
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  statsItem: {
    alignItems: 'center',
    display: 'flex'
  },
  statsIcon: {
    marginRight: theme.spacing(1)
  },
  avatar: {
    width: 'auto',
    height: 'auto'
  }
}));

const BranchOfficeCardPreview = forwardRef(({
  className, branchOffice, onUpload, hasImage, ...rest
}, ref) => {
  const classes = useStyles();
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    ref?.current?.addEventListener('change', () => {
      setPreviewImage(URL.createObjectURL(ref?.current?.files[0]));
    });
  }, []);

  useEffect(() => {
  }, [branchOffice]);

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid container spacing={1}>
          <Grid container item xs={3} direction="column" justify="center" alignItems="center">
            <Avatar
              className={classes.avatar}
              alt="branchOffice"
              src={previewImage || branchOffice?.cover}
              variant="square"
            />
          </Grid>
          <Grid item xs={9}>
            <Typography
              align="left"
              color="textPrimary"
              gutterBottom
              variant="h4"
            >
              {branchOffice?.brand?.name}
              {' '}
              {branchOffice?.name}
            </Typography>
            <Typography
              align="left"
              color="textPrimary"
              gutterBottom
            >
              {branchOffice?.city?.name}
            </Typography>
            <Typography
              align="left"
              color="textPrimary"
              gutterBottom
              variant="caption"
            >
              {branchOffice?.address}
            </Typography>
            <Typography
              align="left"
              color="textPrimary"
              gutterBottom

            >
              Creada:
            </Typography>
            <Typography
              align="left"
              color="textPrimary"
              gutterBottom
              variant="caption"
            >
              {dayjs(branchOffice?.created_at).format('DD MMMM YYYY')}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
      {
        !hasImage && (
          <>
            <Divider />
            <CardActions>
              <Button
                color="primary"
                fullWidth
                variant="text"
                onClick={onUpload}
              >
                Subir Foto
              </Button>
            </CardActions>
          </>
        )
      }
    </Card>
  );
});

BranchOfficeCardPreview.propTypes = {
  className: PropTypes.string,
  branchOffice: PropTypes.object,
  hasImage: PropTypes.bool,
  onUpload: PropTypes.func,
};

BranchOfficeCardPreview.defaultProps = {
  className: '',
  branchOffice: {},
  hasImage: false,
  onUpload: () => { },
};

export default BranchOfficeCardPreview;
